export class MarketplaceApp{
    id : number;
    registerDate : Date;
    status : boolean;
    name : string;
    iconUrl : string;
    provider : string;
    countryConfiguration: CountryConfiguration[];
    languagues : string[];
    unit : string;
    category : string;
    planIds : number;
    projectTypes : string[];
    isDefault : string;
    canChange : string;
    freeTrialDays : number;
    requireCredentials : boolean;
}

export class MarketplaceAppCustom{
    id : number;
    name : string;
    iconUrl : string;
    provider : string;
    countryConfiguration : CountryConfiguration[];
    status : string;
    service : string;
    category? : string;
    pricePlan : PricePlans;
    unit : string;
}

export class MarketplaceAppCustomDto{
    id : number;
    name : string;
    iconUrl : string;
    provider : string;
    countryConfiguration : CountryConfiguration[];
    status : string;
    service : string;
    category? : string;
    pricePlans : PricePlans [];
    unit : string;
    presentationVideoUrl : string;
}

export class PricePlans{
    discount? : string;
    monthlyPrice? : number;
    planId : number
    unitPrice? : number;
    unitPriceWithDiscount? : number;
}

export class CountryConfiguration {
    language : string;
    description : string;
    service: string;
    videoUrl: string | null;
}

export class AppInstallProject {
    marketplaceAppId : number;
    name : string;
    installed : boolean;
}

export enum UNIT{
    MINUTE_UNIT = "MINUTE",
    MESSAGE_UNIT = "MESSAGE",
    CALL_UNIT = "CALL",
    CLIENT_UNIT = "CLIENT",
    TRANSACTION_UNIT = "TRANSACTION",
    CREDIT = "CREDIT",
    MILLION_TOKEN = "MILLION_TOKEN",
    CERTIFICATE = "CERTIFICATE",
    WHATSAPP_EMAIL = "WHATSAPP_EMAIL",
    LETTER = "LETTER"
}

export enum CATEGORY {
    MINUTE_UNIT = "MINUTE",
    MESSAGE_UNIT = "SMS",
    CALL_UNIT = "CALL",
    CLIENT_UNIT = "CLIENT",
    TRANSACTION_UNIT = "TRANSACTION",
    CREDIT_UNIT = "CREDIT",
    COMMUNICATIONS_CATEGORY = "COMMUNICATIONS",
    PAYMENT_METHOD_CATEGORY = "PAYMENT_METHOD",
    MESSAGE_INBOUND_UNIT = "MESSAGE_INBOUND",
    CONNECTION_SERVICE = "CONNECTION",
    CREDITS_SERVICE = "CREDITS",
    AI_AGENT_SERVICE = "AI_AGENT",
    CLOUD_PHONE_SERVICE = "CLOUD_PHONE",
    AI_PHONE_SERVICE = "AI_PHONE",
    MODULE = "MODULE",
    ERP = "ERP",
    WHATSAPP_SERVICE = "WHATSAPP",
    WHATSAPP_CLOUD_API_SERVICE = "WHATSAPP_CLOUD_API",
    ADVISERS_MATRIX = "ADVISERS_MATRIX",
    ADDITIONAL_PROJECT = "ADDITIONAL_PROJECT",
    RECOVERY_PORTFOLIO = "RECOVERY_PORTFOLIO",
    PAYMENT_CONCILIATION = "PAYMENT_CONCILIATION",
    CURRENCY_CONVERSION = "CURRENCY_CONVERSION",
    DELIVERY_CERTIFICATE = "DELIVERY_CERTIFICATE",
    VOICE_NOTE = "VOICE_NOTE",
    PURCHASE_ORDER = "PURCHASE_ORDER",
    COLLECTION_CONCILIATION = "COLLECTION_CONCILIATION",
    FEES_AND_PENALTIES = "FEES_AND_PENALTIES",
    MOONFLOW_ASTERISK_SERVICE = "MOONFLOW_ASTERISK",
    FIELD_MANAGEMENT = "FIELD_MANAGEMENT",
    FIELD_MANAGEMENT_ADDITIONAL = "FIELD_MANAGEMENT_ADDITIONAL",
    MOONFLOW_ASTERISK_ADDITIONAL = "MOONFLOW_ASTERISK_ADDITIONAL",
    PHYSICAL_LETTER_SERVICE = "PHYSICAL_LETTER",
}

export enum CATEGORIES{
    ERP = "ERP",
    COMMUNICATIONS_CATEGORY = "COMMUNICATIONS",
    PAYMENT_METHOD_CATEGORY = "PAYMENT_METHOD",
    MODULE = "MODULE",
    BILLING = "BILLING",
    CREDIT_BUREAU = "CREDIT_BUREAU"
}

export const MARKETPLACE_FILTER_INSTALLED = 'INSTALLED';

export enum SERVICES{
    SMS = "SMS",
    CREDITS = "CREDITS",
    CONNECTION = "CONNECTION",
    AI_AGENT = "AI_AGENT",
    CLOUD_PHONE = "CLOUD_PHONE",
    AI_PHONE = "AI_PHONE",
    WHATSAPP = "WHATSAPP",
    MOONFLOWTALK = "Moonflow Talk",
    CURRENCY_CONVERSION = "CURRENCY_CONVERSION",
    SUBSCRIPTION = 'SUBSCRIPTION',
    ASTERISK = 'MOONFLOW_ASTERISK',
    WHATSAPP_CLOUD_API = 'WHATSAPP_CLOUD_API'
}

export enum APPS_ID{
    CREDITS = 6,
    MOONFLOW_TALK = 5,
    ADVISERS_MATRIX = 34,
    ADDITIONAL_PROJECT = 38,
    DELIVERY_CERTIFICATE = 47,
    RECOVERY_PORTFOLIO = 40,
    CURRENCY_CONVERSION = 42,
    URANOS = 50,
    PURCHASE_ORDER = 58,
    SIP_CALLER_CLOUD_PHONE = 57,
    NEOTEL = 60,
    AI_VOICE_AGENT_MKT_ID = 62,
    LINKUS = 63,
    PAYMENT_CONCILIATION = 65,
    QUANTIC = 69,
    MOONFLOW_ASTERISK = 72,
    MOONFLOW_ASTERISK_ADDITIONAL = 84,
    ALDEAMO = 74,
    KUESKI_SMS = 75,
    KUESKI_EMAIL = 78,
    KUESKI_WHATSAPP = 76,
    KUESKI_CALL = 77,
    KUESKI_PUSH = 79,
    FIELD_MANAGEMENT = 81,
    FIELD_MANAGEMENT_ADDITIONAL = 82,
    POSTGRID = 88
}
